/* eslint-disable prefer-template */
/* eslint-disable no-param-reassign */
/* eslint linebreak-style: ["error", "windows"] */
/**
 * ===========================
 * @author:  am2Studio      ==
 * @package: JS Bundle      ==
 * @version: 2.0.0          ==
 * ===========================
 *
 * @description: {
 * --- @usage {
 * a) plugins we develop for AM2 goes into plugins - reusable stuff
 * b) helpers will contain globally used functions, examples bellow
 * c) routes and its subfolders contains JS that applies for specific block/templates
 * d) vendor contains vendor JS - Should be enqueued with WP or lazyloaded with `loadJs`
 * }
 * --- @structure {
 * a) any plugin we create goes to `/plugins/` folder, should extend main component
 * b) any helper functions goes to `/helpers/` folder (debounce, parseData etc)
 * c) route specific js goes to `/routes/name/index.js` or if its functionality is large
 * you can create multiple files and import them in the index file
 * }
 *
 * @JSManager { The class that handles JS loading/running
 * - common js `init` key runs first
 * - route specific js `init`/`complete` keys runs after common (same order)
 * - common js `complete` key runs after
 * - any other lazyloaded JS runs last of course
 * }
 *
 * @loadJs {
 * - I've removed our old way of loading js since this one allows more flexibility
 * - and it allo allows to load multiple files then run your code, including css
 * - `https://github.com/muicss/loadjs`
 * }
 */

import './../scss/style.scss';

// JSManager + Core Component (used for making JS plugins)
import loadjs from 'loadjs';
import './plugins/am2-Component';
import './plugins/am2-JSManager';

// Helpers
import helperDebounce from './helpers/debounce';
import helperParseData from './helpers/parseData';
import helperGenParams from './helpers/createParams';

// Common JS
import common from './routes/common';

// Blocks
import am2Tabs from './routes/blocks/tabs';
import am2Slider from './routes/blocks/slider';
import am2GoogleMap from './routes/blocks/gmaps';
import am2Accordion from './routes/blocks/accordion';

/**
 * Routed JS - loaded on specific block/template (if it exists in body class)
 * @see - class-am2-hooks.php @ body_class() filter function
 * @info - each block will generate a class like: am2-{ block-name }
 */

// Attach Some Required Plugins
am2.fn = {};
am2.fn.loadJs = loadjs;
am2.fn.debounce = helperDebounce;
am2.fn.getOptions = helperParseData;
am2.fn.createParams = helperGenParams;
am2.fn.getDocumentScrollTop = () => window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

// Attach Specific Route JS
am2 = {
	...am2,
	...{
		routes: {
			/**
			 * @description
			 * This prop includes the global JS fired on every page
			 * All the js that needs to be loaded everywhere should be placed in `common` folder
			 * There you can split your files into multiple parts based on your needs
			 * @reserved Key
			 */
			common,
			// Route created before using handleBodyClasses() in the common js
			// IE JS, runs only if is IE detected - just for demo that you can do that also
			// This route should be removed on production
			isIE: {
				init: () => console.log("Update this ancient tool."),
				complete: () => alert("Still not updated this browser ?"),
				extends: ["is-EDGE"],
			},
			// Sliders
			am2Slider,
			// Tabs
			am2Tabs,
			// Accordios
			am2Accordion,
			// Google Maps
			am2GoogleMap,
		},
	},
};
